import { useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

export default function useActions<T = Record<string, any>>(actions = {}) {
  const dispatch = useDispatch();
  const actionsRef = useRef(actions);

  return useMemo<T>(() => bindActionCreators(actionsRef.current, dispatch) as T, [dispatch]);
}
